import React, { Component } from 'react';
import '../../static/fonts/AlmoniTzarAAA/stylesheet.css';
import './Gallery.scss';
import Coverflow from 'reactjs-coverflow';
import {GA_Event} from '../Analytics/Analytics'

import { isMobile, isIos } from '../../static/helper';

class Gallery extends Component {
  constructor() {
    super();
    this.data = [
      { imagePath: '', city: '', url: '' },



      { imagePath: '/images/cities/desktop/kfarsaba.jpg', city: 'כפר-סבא', url: 'https://kfarsaba.mynet.co.il' },
      { imagePath: '/images/cities/desktop/herzliya.jpg', city: 'הרצליה', url: 'https://herzliya.mynet.co.il' },
      { imagePath: '/images/cities/desktop/batyam.jpg', city: 'בת ים', url: 'https://batyam.mynet.co.il' },
      { imagePath: '/images/cities/desktop/holon.jpg', city: 'חולון', url: 'https://holon.mynet.co.il' },
      { imagePath: '/images/cities/desktop/netanya.jpg', city: 'נתניה', url: 'https://netanya.mynet.co.il' },
      { imagePath: '/images/cities/desktop/rishon.jpg', city: 'ראשון-לציון', url: ' https://rishon.mynet.co.il' },
      { imagePath: '/images/cities/desktop/petahtikva.jpg', city: 'פתח-תקוה', url: 'https://petahtikva.mynet.co.il' },
      { imagePath: '/images/cities/desktop/krayot.jpg', city: 'קריות', url: 'https://krayot.mynet.co.il' },
      { imagePath: '/images/cities/desktop/beersheva.jpg', city: 'באר-שבע', url: 'https://beersheva.mynet.co.il' },
      { imagePath: '/images/cities/desktop/jerusalem.jpg', city: 'ירושלים', url: 'https://jerusalem.mynet.co.il' },
      { imagePath: '/images/cities/desktop/hadera.jpg', city: 'חדרה', url: 'https://hadera.mynet.co.il' },
      { imagePath: '/images/cities/desktop/rehovot.jpg', city: 'רחובות', url: 'https://rehovot.mynet.co.il' },
      { imagePath: '/images/cities/desktop/roshhaayin.jpg', city: 'ראש העין', url: 'https://roshhaayin.mynet.co.il' },
      { imagePath: '/images/cities/desktop/afula.jpg', city: 'העמק', url: 'https://emek.mynet.co.il' },
      { imagePath: '/images/cities/desktop/raanana.jpg', city: 'רעננה', url: 'https://raanana.mynet.co.il' },
      { imagePath: '/images/cities/desktop/hodhasharon.jpg', city: 'הוד השרון', url: 'https://hodhasharon.mynet.co.il' },
      { imagePath: '/images/cities/desktop/modiin.jpg', city: 'מודיעין', url: 'https://modiin.mynet.co.il' },
      { imagePath: '/images/cities/desktop/kibbutz.jpg', city: 'קיבוץ', url: 'https://kibbutz.mynet.co.il' },
      { imagePath: '/images/cities/desktop/haifa.jpg', city: 'חיפה', url: 'https://haifa.mynet.co.il' },
   


      { imagePath: '', city: '', url: '' },
    ];
    this.dataElements = [];
  }
  next = (e) => {
    e.preventDefault();
    this.refs.coverflow.next();
  }
  getPosition = (e) => {
    e.preventDefault();
    return this.refs.coverflow.getPosition();
  }
  prev = (e) => {
    e.preventDefault();
    this.refs.coverflow.previous();
  }
  goAt = (num, e) => {
    console.log(num);
    if (e) {
      e.preventDefault();
    }
    this.refs.coverflow.goAt(num);
    // if (num === 0) {
    //   setTimeout(() => {
    //     this.next(e);
    //     this.prev(e);
    //   }, 500);
    // }
  }

  search = (e) => {
    let index = 0;
    const searchWord = e.target.value;
    if (searchWord.length >= 2) {
      let temp = this.data.findIndex((item) => item.city.indexOf(searchWord) === 0);
      if (temp > -1) {
        this.goAt(temp, e);
      }
    }
  }

  onChange = (position) =>{
    if(position === 0){
      if(this.refs.coverflow.getPosition() === 1){
        setTimeout(() => {
          this.refs.coverflow.next();
        }, 300);
      }
      else{
      this.refs.coverflow.next();
      }
    }
    if(position === this.data.length - 1){
      if(this.refs.coverflow.getPosition() === this.data.length - 2){
        setTimeout(() => {
          this.refs.coverflow.previous();
        }, 300);
      }
      else{
      this.refs.coverflow.previous();
      }
    }
  }


  render() {
    if (this.data.length > 0) {
      this.data.map((item, i) => {
        this.dataElements.push(
          <div className="image-container" onClick={() => GA_Event('local_mynet_event', 'Go to Local Mynet' ,item.city, item.url.replace("https://" , ""))}>
            {item.url !== '' ?
              <>
                <a href={item.url} target="_blank"><img key={i} src={isMobile() || isIos() ? process.env.PUBLIC_URL + item.imagePath.replace("desktop/", "") : process.env.PUBLIC_URL + item.imagePath} /></a>
                <label className="city">{item.city}</label>
              </>
              : ""
            }
          </div>
        )
      })
    }
    return (
      <div className="container">
        <div className="search-container">
          <input placeholder="מצאו את הישוב שלכם" className="search" type="text" onChange={this.search} />
        </div>
        <div className="video-wrapper">

          <div className="video-coverflow">
            {this.dataElements.length > 0 ?
              <Coverflow ref="coverflow"
                style={{ width: "100%", height: "100%" }}
                margin={"0px"}
                startPosition={Math.round((this.dataElements.length - 1) / 2)}
                enableScroll={true}
                rotate={45}
                animationSpeed={0.8}
                onChange={(position) => this.onChange(position)}
                infiniteScroll={true}
              >
                {this.dataElements}
              </Coverflow>
              : ""
            }
            <div className="arrows">
              <div onClick={this.next} className="arrow right"></div>
              <div onClick={this.prev} className="arrow left"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Gallery;

// <Coverflow ref="coverflow" width="1920" height="386"
//                 displayQuantityOfSide={1}
//                 navigation={false}
//                 enableScroll={true}
//                 clickable={true}
//                 enableHeading={true}
//                 active={0}
//                 currentFigureScale={1}
//                 otherFigureScale={.7}
//                 >
//                 {this.dataElements}
//               </Coverflow>
//               : ""